import React from "react";

interface LabeledInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    showLabel?: boolean;
    labelClassName?: string;
    inputClassName?: string;
    name: string; // required so we can use for both id and name
    type?: "text" | "textarea";
    placeholder?: string;
}

const LabeledInput: React.FC<LabeledInputProps> = ({
    label,
    showLabel = true,
    labelClassName = "",
    inputClassName = "",
    name,
    type = "text",
    placeholder,
    ...inputProps
}) => (
    <div className="w-full">
        <div>
            {showLabel && label && (
                <label htmlFor={name} className={labelClassName}>
                    {label}
                </label>
            )}
            {type === "textarea" ? (
                <textarea
                    id={name}
                    name={name}
                    className={inputClassName}
                    {...(inputProps as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
                />
            ) : (
                <input
                    id={name}
                    name={name}
                    type={type}
                    className={inputClassName}
                    placeholder={placeholder}
                    {...inputProps}
                />
            )}
        </div>
    </div>
);

export default LabeledInput;